'use client';

import { useEffect, useState } from 'react';
import { useLanguage } from '@/context/LanguageContext';

export function LanguageLoader() {
  const { translationsLoaded } = useLanguage();
  const [isVisible, setIsVisible] = useState(true);
  const [shouldRender, setShouldRender] = useState(true);

  useEffect(() => {
    if (translationsLoaded) {
      // Start fade out animation
      setIsVisible(false);
      // Remove from DOM after animation completes
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300); // Match CSS transition duration
      return () => clearTimeout(timer);
    }
  }, [translationsLoaded]);

  if (!shouldRender) {
    return null;
  }

  return (
    <div className={`language-loader ${isVisible ? 'visible' : 'fade-out'}`}>
      <div className="language-loader-content">
        <div className="language-loader-spinner"></div>
      </div>
    </div>
  );
}

